import { fragments } from '@/gql'
import gql from 'graphql-tag'
const q = gql`
    query SearcherResultCom(
      $searcherType: SearcherType,
      $itemType: String!, 
      $limit: Int, 
      $offset: Int, 
      $value: Value, 
      $filters: [Filter],
      $elIncludes: [ElInclude],
      $defaultConfidence: Float,
      $queryType: String,
      $hideAggs: Boolean,
      $hideMatches: Boolean,
      $noCache: Boolean
    ) {
      SearcherResultCom: SearcherResult (
        searcherType: $searcherType, 
        limit: $limit, 
        offset: $offset, 
        value: $value,
        filters: $filters,
        itemType: $itemType,
        elIncludes: $elIncludes,
        defaultConfidence: $defaultConfidence,
        queryType: $queryType,
        hideAggs: $hideAggs,
        hideMatches: $hideMatches,
        noCache: $noCache
      ) {
        ...comSearcherResult
      }
    }
    ${fragments.comMatchDetail}
    ${fragments.comSearcherResult}
    ${fragments.comSearchers}
    ${fragments.searchItems}
    ${fragments.comMatchReason}
  `
export default q
